import BigWrapper from "./BigWrapper";

const Footer = () => {
  return (
    <BigWrapper>
      <div className="text-center">
        <p>Thank you for visiting my profile.</p>
        <p className="mt-4 font-mono text-blue-500">
          Made using ReactJS + Tailwind CSS
        </p>
      </div>
    </BigWrapper>
  );
};

export default Footer;
